"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.nftHolders = void 0;
exports.nftHolders = `query GetNftHolders($before: String, $receipt: String!) {
  objects(last: 10, before: $before, filter: { type: $receipt }) {
    pageInfo {
      hasNextPage
      hasPreviousPage
      endCursor
      startCursor
    }
    nodes {
      asMoveObject {
        status
        contents {
          json
        }
      }
    }
  }
}
`;
//# sourceMappingURL=nftHolders.js.map